import { render, staticRenderFns } from "./GestionClientFeedbackS2.vue?vue&type=template&id=5feb4503&"
import script from "./GestionClientFeedbackS2.vue?vue&type=script&lang=js&"
export * from "./GestionClientFeedbackS2.vue?vue&type=script&lang=js&"
import style0 from "./GestionClientFeedbackS2.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports